import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { OverlayEventDetail } from '@ionic/core';
import { CardioProgramBuilderPage } from '../pages/client/cardio-program-builder/cardio-program-builder.page';

interface OpenCardioProgramBuilderModalOptions {
  id?: string;
  type?: 'user' | 'library';
  userId?: string;
  duplicate?: string;
  mode?: 'program' | 'category';
  backdropDismiss?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class CardioProgramBuilderModalService {
  constructor(private modalCtrl: ModalController) {}

  async open(options: OpenCardioProgramBuilderModalOptions = {}): Promise<OverlayEventDetail<any>> {
    const modal = await this.modalCtrl.create({
      component: CardioProgramBuilderPage,
      cssClass: 'meal-plan-side-modal',
      backdropDismiss: options.backdropDismiss ?? false,
      componentProps: {
        modalContext: {
          cardioProgramUser: options.userId,
          id: options.id || 'add',
          type: options.type || 'user',
          ...(options.mode ? { mode: options.mode } : {}),
          ...(options.duplicate ? { duplicate: options.duplicate } : {}),
        },
      },
    });

    await modal.present();
    return modal.onDidDismiss();
  }
}
